/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorCounselingRequestBillingTypename = "PharmacyCounselorCounselingRequestBilling" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorCounselingRequestBilling
 */
export interface PharmacyCounselorCounselingRequestBilling {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorCounselingRequestBilling
   */
  authorizationPaymentId?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorCounselingRequestBilling
   */
  paymentMethod: PharmacyCounselorCounselingRequestBillingPaymentMethodEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorCounselingRequestBilling
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorCounselingRequestBillingPaymentMethodEnum {
  Counter = "counter",
  Online = "online",
  MedicalSupport = "medical_support",
  MccmDigitalPlatform = "mccm_digital_platform",
  Other = "other",
}

export function PharmacyCounselorCounselingRequestBillingFromJSON(
  json: any
): PharmacyCounselorCounselingRequestBilling {
  return PharmacyCounselorCounselingRequestBillingFromJSONTyped(json, false);
}

export function PharmacyCounselorCounselingRequestBillingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorCounselingRequestBilling {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorCounselingRequestBillingTypename,

    authorizationPaymentId: !exists(json, "authorization_payment_id") ? undefined : json["authorization_payment_id"],
    paymentMethod: json["payment_method"],
  };
}

export function PharmacyCounselorCounselingRequestBillingToJSON(
  object?: PharmacyCounselorCounselingRequestBilling | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    authorization_payment_id: value.authorizationPaymentId,
    payment_method: value.paymentMethod,
  };
}
